module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_9-920b9703354526407483ed7db5ed15f6.png";